<template>
  <div>
    <EventListener
      :events="[
        'add_withdrawal_account',
        'withdrawal_account_created',
        'failed_to_create_withdrawal_account',
        'failed_to_update_withdrawal_account',
      ]"
      @add_withdrawal_account="initNewAccountAdding"
      @withdrawal_account_created="onAccountCreated"
      @failed_to_create_withdrawal_account="onAccountAddingFailed"
    />
    <OtpValidation ref="otpValidator" @otp_validated="onOtpValidated" />
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
        }
      "
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import EventListener from '../utils/EventListener.vue'
import OtpValidation from '../utils/OtpValidation.vue'
import UserProperty from '../user/UserProperty.vue'

export default defineComponent({
  name: 'WithdrawalAccountDetails',
  components: {
    EventListener,
    OtpValidation,
    UserProperty,
  },
  props: {},
  data() {
    return {
      newAccountData: {},
      userData: {},
    }
  },
  mounted() {},
  methods: {
    async initNewAccountAdding({ accountTypeName }) {
      let data
      if (accountTypeName == 'bank')
        data = await this.promptBankAccountCreation()
      else
        data = await this.promptMomoAccountCreation()
      if (!data) return
      this.newAccountData = data
      this.$refs.otpValidator.validateEmail({
        email: this.userData?.email,
        firstName: this.userData?.firstName,
      })
    },
    async promptBankAccountCreation() {
      const prompt = await window.customPrompt({
        title: 'Nouveau compte de reversement',
        // subTitle: 'Ajouter un compte de reversement',
        formFields: [
          {
            type: 'select',
            propertyName: 'country',
            label: 'Pays de la banque',
            options: this.$Countries.getSignupCountries().sort((ca, cb) => {
              if (ca.countryName > cb.countryName) return 1
              if (ca.countryName < cb.countryName) return -1
              return 0
            }),
            formatOptionInputDisplay(country) {
              return `${country.countryName}`
            },
            formatOptionsDisplay(country) {
              return `<div class="flex text-lg justify-between w-full items-center h-[30px] relative"><span>${
                country.countryName
              }</span><span class="absolute left-[calc(100vw-90px)]">${
                country.countryFlag
              }</span></div>`
            },
            inputProps: {
              selectTitle: 'Séléctionnez un pays',
              useModal: true,
            },
            defaultValue: `Bénin`,
            required: true,
          },
          {
            type: 'text',
            label: 'intitulé du compte',
            propertyName: 'name',
            defaultValue: '',
            required: true,
            class: '',
          },
          {
            type: 'text',
            label: 'Numéro du compte banciare',
            propertyName: 'accountId',
            placeHolder: '',
            defaultValue: '',
            required: true,
            class: '',
          },
          {
            type: 'text',
            label: 'Nom de la banque',
            propertyName: 'bankName',
            placeHolder: '',
            defaultValue: '',
            required: true,
            class: '',
          },
          {
            type: 'text',
            label: 'Code de banque',
            propertyName: 'bankCode',
            placeHolder: '',
            defaultValue: '',
            required: true,
            class: '',
          },
          {
            type: 'text',
            label: 'Code guichet',
            propertyName: 'boxCode',
            placeHolder: '',
            defaultValue: '',
            required: true,
            class: '',
          },
        ],
        successText: 'Créer compte',
      })
      if (!prompt.accepted) return null
      const data = {
        accountType: 'bank',
        ...prompt.data,
        countryCode: prompt.data.country?.countryCode || 'BJ',
      }
      await new Promise(r => setTimeout(r, 500))
      return data
    },
    async promptMomoAccountCreation() {
      const prompt = await window.customPrompt({
        title: 'Nouveau compte de transfert',
        // subTitle: 'Ajouter un compte de reversement',
        formFields: [
          {
            type: 'select',
            propertyName: 'country',
            label: 'Pays de la banque',
            options: this.$Countries.getSignupCountries().sort((ca, cb) => {
              if (ca.countryName > cb.countryName) return 1
              if (ca.countryName < cb.countryName) return -1
              return 0
            }),
            formatOptionInputDisplay(country) {
              return `${country.countryName}`
            },
            formatOptionsDisplay(country) {
              return `<div class="flex text-lg justify-between w-full items-center h-[30px] relative"><span>${
                country.countryName
              }</span><span class="absolute left-[calc(100vw-90px)]">${
                country.countryFlag
              }</span></div>`
            },
            inputProps: {
              selectTitle: 'Séléctionnez un pays',
              useModal: true,
            },
            defaultValue: `Bénin`,
            required: true,
          },
          {
            type: 'text',
            label: 'intitulé du compte',
            propertyName: 'name',
            defaultValue: '',
            required: true,
            class: '',
          },
          {
            type: 'text',
            label: 'Numéro Mobile Money',
            propertyName: 'accountId',
            placeHolder: '',
            defaultValue: '',
            required: true,
            class: '',
          },
          {
            type: 'select',
            label: 'Opérateur téléphonique',
            propertyName: 'operator',
            options: [
              'MTN', 'MOOV', "ORANGE", "FREE", "TOGOCEL"
            ],
            placeHolder: '',
            defaultValue: '',
            required: true,
            class: '',
          },
        ],
        successText: 'Créer compte',
      })
      if (!prompt.accepted) return null
      const data = {
        accountType: 'mobileMoney',
        ...prompt.data,
        countryCode: prompt.data.country?.countryCode || 'BJ',
      }
      await new Promise(r => setTimeout(r, 500))
      return data
    },

    onOtpValidated() {
      this.$Events.dispatchEvent(
        'new_withdrawal_account_ready_to_be_added',
        this.newAccountData,
      )
      this.$Events.dispatchEvent('start_loading')
    },
    onAccountCreated() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Compte créé',
        body: 'Votre compte a té créé avec succès avec succès',
      })
    },
    onAccountAddingFailed() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Compte non créé',
        body: 'Erreur de création du compte, veuillez réessayer',
      })
    },
  },
  computed: {},
})
</script>
